import { OrderByModalTypes } from '../../../../../../components/OrderByModal';

export const orderValuesRules: Record<string, Partial<OrderByModalTypes.OrderByStructure>> = {
  productDisplay: {
    hideDefaultIcon: true,
    customChar: ['A-Z', 'Z-A'],
  },
  unitPrice: { customChar: ['$'] },
  profitabilityTax: { customChar: ['%'] },
  profitabilityYearly: { customChar: ['%'] },
};

export const getOrderValuesByValue = (value?: string) => {
  if (!value) {
    return {};
  }
  return orderValuesRules[value as keyof typeof orderValuesRules] || {};
};
